module.exports = __webpack_public_path__ + "static/w-ulfi-c2cbea8bfdd56a2987c63349c2d483c6.png";